import React from 'react';
import { Footer } from './styles';

export default function () {
  return (
    <Footer className="footer-fix">
      <ul>
        <li>
          <span>Copyright © 2020 Vrio Corp. All rights reserved.</span>
        </li>
      </ul>
    </Footer>
  );
}
